<template>
  <div class="info_cheart_ctCt">
    <el-card style="height:100%">
      <div class="warp_userInfo">
        <div class="user_z">
          <div class="title_u">重点企业</div>
          <ul class="ulO">
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
          </ul>
        </div>
        <div class="user_k">
          <div class="title_u">关注企业</div>
          <ul class="ulO">
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
          </ul>
        </div>
        <div class="user_l">
          <div class="title_u">走访企业</div>
          <ul class="ulO">
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
            <li>北京安诺信科技股份有限公司</li>
            <li>北京安软信息科技有限公司</li>
            <li>北京邦克佳软信息技术有限责任公司</li>
          </ul>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { infoDataSetGir } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
.info_cheart_ctCt {
  height: 400px;
  margin-top: 20px;
  .el-card__body {
    height: 100%;
  }
  .warp_userInfo {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    .user_z {
      .title_u {
        padding-bottom: 20px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #333333;
      }
      .ulO li {
        height: 30px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #155ea1;
      }
    }
    .user_k {
      .title_u {
        padding-bottom: 20px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #333333;
      }
      .ulO li {
        height: 30px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #155ea1;
      }
    }
    .user_l {
      .title_u {
        padding-bottom: 20px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #333333;
      }
      .ulO li {
        height: 30px;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #155ea1;
      }
    }
  }
}
</style>
